module.exports = __webpack_public_path__ + "static/media/Culture_Corporates.1dd35344.png";